

    <a  href="{`mailto:${to}`}">{to}</a>

<script>

export let to;

</script>
